import { render, staticRenderFns } from "./ctlQuoteActivities.vue?vue&type=template&id=07f75460&"
import script from "./ctlQuoteActivities.vue?vue&type=script&lang=js&"
export * from "./ctlQuoteActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ctlQuoteActivities.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VFlex,
  VLayout,
  VToolbar,
  VToolbarTitle,
})
